import {createApp} from 'vue'
import router from "/js/router/routes";
import {RouterView} from "vue-router";

const element = document.getElementById("app")
if (element) {
  const app = createApp(RouterView)
  app.use(router)
  app.mount(element)
}